export const translations = {
  de: {
    nav: {
      home: "Home", booking: "Biographie", music: "Musik", albums: "Alben",
      videos: "Videos", gallery: "Galerie", live: "Live", contact: "Kontakt",
    },
    hero: {
      kicker: "Italienischer Sänger · Pianist · Entertainer",
      lead: "Italienische Leidenschaft. Zeitlose Musik. Unverwechselbarer Stil. Giovanni Costello verbindet Gesang, Piano und Entertainment zu besonderen Momenten – elegant, charismatisch und mit der Seele Italiens.",
      ctaMusic: "Musik entdecken",
      ctaBook: "Buchen",
      listenOn: "Hören auf",
      scroll: "Scrollen",
    },
    marquee: "IN ALTO MARE · TRUE ITALIAN STORIES · LIVE MIT DER SWR BIG BAND · TENDERNESS · SPLENDIDO · IL GIOCO · ",
    about: {
      label: "Kapitel 01 · Der Künstler",
      title: "Ein Gentleman am Klavier",
      chapters: [
        {
          num: "01",
          title: "Die Samtstimme des italienischen Swing",
          text: "Giovanni Costello verkörpert den zeitlosen Charme des klassischen italienischen Gentleman. Seine warme Baritonstimme verbindet die Tradition italienischer Cantautori mit den mitreißenden Bläsersätzen einer großen Big Band. Elegant, souverän, unverwechselbar.",
        },
        {
          num: "02",
          title: "Vom Konservatorium auf die großen Bühnen",
          text: "Am Konzertflügel erschafft Giovanni Intimität und Leidenschaft zugleich. Ob TV Auftritte bei The Voice of Germany und Canale 5, Konzerte mit der SWR Big Band oder Open Air Galas: Seine Auftritte sind Momente, die bleiben.",
        },
        {
          num: "03",
          title: "Eigene Songs, eigene Geschichten",
          text: "Mit Alben wie »In Alto Mare«, »True Italian Stories« und »Splendido« erzählt Giovanni italienische Geschichten in eigener Handschrift, zwischen Jazz, Swing und mediterraner Sehnsucht.",
        },
      ],
    },
    albums: {
      label: "Kapitel 02 · Diskografie",
      title: "Alben & Musik",
      sub: "Originalalben von Giovanni Costello. Fahre über ein Album oder tippe es an, um die Tracklist zu sehen.",
      tracklist: "Tracklist",
      buyCd: "CD kaufen",
      added: "zum Warenkorb hinzugefügt",
      listenOn: "Streamen auf",
      year: "Jahr",
      tracklistPending: "Tracklist folgt in Kürze.",
      sampleNote: "",
    },
    videos: {
      label: "Kapitel 03 · Bühne & Screen",
      title: "Videos & Performances",
      sub: "Live Momente, TV Auftritte und offizielle Musikvideos, direkt von YouTube.",
      watchOn: "Auf YouTube ansehen",
    },
    gallery: {
      label: "Kapitel 04 · Bilder",
      title: "Galerie",
      sub: "Portraits, Bühne, Studio und besondere Momente.",
      close: "Schließen",
    },
    live: {
      label: "Kapitel 05 · Auf Tour",
      title: "Live & Konzerte",
      sub: "Kommende Auftritte. Neue Termine werden laufend ergänzt.",
      tickets: "Tickets",
      soon: "Demnächst",
      available: "Tickets verfügbar",
      fast: "Fast ausverkauft",
      vip: "Nur noch VIP",
      sampleNote: "Beispieltermine, die mit den offiziellen Konzertdaten ersetzt werden.",
      socialNote: "Live Termine und Konzerte sind auch auf Social Media zu finden, zum Beispiel auf Instagram und Facebook.",
    },
    booking: {
      label: "Kapitel 01 · Biographie",
      kicker: "Italienischer Sänger, Pianist & Entertainer für elegante Events",
      lead1: "Italienische Leidenschaft, musikalische Eleganz und eine Stimme mit unverwechselbarem Charakter. Giovanni Costello begann seine musikalische Reise bereits als Kind in Italien und führte sie über internationale Bühnen bis ins deutsche Fernsehen. Heute verbindet er Gesang, Piano, Jazz, Pop und italienische Klassiker zu seinem ganz persönlichen Stil.",
      lead2: "Ob intime Piano-Musik, stilvolle Gala oder große Live-Show mit Big Band – Giovanni schafft besondere Momente und eine Atmosphäre, die Menschen verbindet. Ein echter italienischer Entertainer mit Charme, Persönlichkeit und der Leidenschaft für die große Bühne.",
      tags: "Firmenveranstaltungen · Gala Dinners · Luxus Events · Private Feiern · Band",
      entTitle: "Live Entertainment für außergewöhnliche Events",
      entIntro: "Manche Abende verlangen nach mehr als Hintergrundmusik. Giovanni Costello verbindet die Eleganz eines Pianisten mit der Präsenz eines internationalen Live Entertainers. Sein Repertoire aus italienischen Klassikern, Jazz, Swing und zeitlosen Popsongs ist gemacht für elegante Anlässe, bei denen Musik die Atmosphäre ergänzen soll und, wenn der Moment es verlangt, zum Höhepunkt des Abends wird.",
      categories: [
        { title: "Firmenveranstaltungen", text: "Anspruchsvolle Unterhaltung für Firmenfeiern, Executive Dinners, Kundenevents, Konferenzen, Produktlaunches und Empfänge." },
        { title: "Gala Dinners", text: "Elegante Piano und Gesangsauftritte für prestigeträchtige Dinners, Preisverleihungen, Charity Galas und formelle Abendveranstaltungen." },
        { title: "Luxus & Private Events", text: "Ein unverwechselbares Live Musikerlebnis für Hochzeiten, private Feiern, exklusive Dinners und besondere Anlässe." },
        { title: "Big Band Events", text: "Für größere Produktionen tritt Giovanni Costello mit einer kompletten Big Band auf und schafft die Atmosphäre eines stilvollen italienischen Konzertabends." },
      ],
      closing: "Buchbar als Piano und Gesang, mit Band oder mit Big Band.",
      photoLabel: "Live Entertainment · Piano und Gesang",
      cta: "Anfrage senden",
    },
    contact: {
      label: "Kontakt",
      title: "Management & Booking",
      sub: "Anfragen für Konzerte, Galas, TV und Presse.",
      name: "Name / Firma",
      email: "E-Mail",
      subject: "Betreff / Anlass",
      message: "Nachricht",
      send: "Nachricht senden",
      success: "Grazie! Deine Nachricht wurde gesendet.",
      error: "Senden fehlgeschlagen. Bitte später erneut versuchen.",
    },
    cart: {
      title: "Warenkorb",
      empty: "Dein Warenkorb ist leer.",
      emptyCta: "Alben entdecken",
      subtotal: "Zwischensumme",
      shipping: "Versand",
      free: "Kostenlos",
      freeFrom: "Kostenloser Versand ab 50 €",
      total: "Gesamt",
      checkout: "Zur Kasse",
      continue: "Weiter stöbern",
      remove: "Entfernen",
    },
    checkout: {
      title: "Kasse",
      back: "Zurück zum Shop",
      contact: "Kontaktdaten",
      address: "Lieferadresse",
      firstName: "Vorname",
      lastName: "Nachname",
      email: "E-Mail-Adresse",
      phone: "Telefon (optional)",
      street: "Straße & Nr.",
      zip: "PLZ",
      city: "Stadt",
      country: "Land",
      delivery: "Versandart",
      standard: "Standard (3–5 Werktage)",
      express: "Express (1–2 Werktage)",
      payment: "Zahlungsmethode",
      paymentNote: "Die Zahlung wird über einen sicheren Zahlungsanbieter abgewickelt. Es werden keine Zahlungsdaten auf dieser Website gespeichert.",
      summary: "Deine Bestellung",
      legal: "Mit Klick auf »Kostenpflichtig bestellen« akzeptierst du die AGB und Widerrufsbelehrung.",
      place: "Kostenpflichtig bestellen",
      processing: "Wird verarbeitet …",
      empty: "Dein Warenkorb ist leer.",
      emptyCta: "Zurück zu den Alben",
      error: "Bestellung fehlgeschlagen. Bitte erneut versuchen.",
      countries: ["Deutschland", "Österreich", "Schweiz", "Italien"],
    },
    confirmation: {
      title: "Grazie mille!",
      sub: "Vielen Dank für deine Bestellung.",
      orderNo: "Bestellnummer",
      emailNote: "Eine Bestätigung wird zusätzlich per E-Mail verschickt.",
      paymentNote: "Die Zahlung wird über den gewählten Zahlungsanbieter abgeschlossen (Integration folgt).",
      items: "Bestellte Artikel",
      total: "Gesamtbetrag",
      continue: "Weiter Musik entdecken",
      notFound: "Bestellung nicht gefunden.",
    },
    footer: {
      tagline: "Italienischer Sänger · Pianist · Entertainer",
      rights: "Alle Rechte vorbehalten.",
      impressum: "Impressum",
      privacy: "Datenschutz",
      follow: "Folgen",
    },
    photo: "FOTO",
    photoHint: "Originalfoto hier einfügen",
  },
  en: {
    nav: {
      home: "Home", booking: "Biography", music: "Music", albums: "Albums",
      videos: "Videos", gallery: "Gallery", live: "Live", contact: "Contact",
    },
    hero: {
      kicker: "Italian Singer · Pianist · Entertainer",
      lead: "Italian passion. Timeless music. Unmistakable style. Giovanni Costello combines vocals, piano and entertainment into special moments: elegant, charismatic and with the soul of Italy.",
      ctaMusic: "Discover the Music",
      ctaBook: "Book Now",
      listenOn: "Listen on",
      scroll: "Scroll",
    },
    marquee: "IN ALTO MARE · TRUE ITALIAN STORIES · LIVE WITH THE SWR BIG BAND · TENDERNESS · SPLENDIDO · IL GIOCO · ",
    about: {
      label: "Chapter 01 · The Artist",
      title: "A Gentleman at the Piano",
      chapters: [
        {
          num: "01",
          title: "The Velvet Voice of Italian Swing",
          text: "Giovanni Costello embodies the timeless charm of the classic Italian gentleman. His warm baritone fuses the tradition of Italian cantautori with the exhilarating brass of a full big band. Elegant, assured, unmistakable.",
        },
        {
          num: "02",
          title: "From the Conservatory to Grand Stages",
          text: "At the grand piano Giovanni creates intimacy and passion alike. From TV appearances on The Voice of Germany and Canale 5 to concerts with the SWR Big Band and open air galas: his performances are moments that stay.",
        },
        {
          num: "03",
          title: "His Own Songs, His Own Stories",
          text: "With albums like »In Alto Mare«, »True Italian Stories« and »Splendido«, Giovanni tells Italian stories in his own hand, between jazz, swing and Mediterranean longing.",
        },
      ],
    },
    albums: {
      label: "Chapter 02 · Discography",
      title: "Albums & Music",
      sub: "Original albums by Giovanni Costello. Hover over an album or tap it to reveal the tracklist.",
      tracklist: "Tracklist",
      buyCd: "Buy CD",
      added: "added to cart",
      listenOn: "Stream on",
      year: "Year",
      tracklistPending: "Tracklist coming soon.",
      sampleNote: "",
    },
    videos: {
      label: "Chapter 03 · Stage & Screen",
      title: "Videos & Performances",
      sub: "Live moments, TV appearances and official music videos, straight from YouTube.",
      watchOn: "Watch on YouTube",
    },
    gallery: {
      label: "Chapter 04 · Imagery",
      title: "Gallery",
      sub: "Portraits, stage, studio and special moments.",
      close: "Close",
    },
    live: {
      label: "Chapter 05 · On Tour",
      title: "Live & Concerts",
      sub: "Upcoming performances. New dates are added continuously.",
      tickets: "Tickets",
      soon: "Coming soon",
      available: "Tickets available",
      fast: "Selling fast",
      vip: "VIP seats only",
      sampleNote: "Sample dates, to be replaced with official concert data.",
      socialNote: "Live dates and concerts can also be found on social media, for example on Instagram and Facebook.",
    },
    booking: {
      label: "Chapter 01 · Biography",
      kicker: "Italian Singer, Pianist & Entertainer for Elegant Events",
      lead1: "Italian passion, musical elegance and a voice of unmistakable character. Giovanni Costello began his musical journey as a child in Italy and carried it across international stages to German television. Today he blends vocals, piano, jazz, pop and Italian classics into his very own style.",
      lead2: "Whether intimate piano music, an elegant gala or a grand live show with a big band, Giovanni creates special moments and an atmosphere that connects people. A true Italian entertainer with charm, personality and a passion for the big stage.",
      tags: "Corporate Events · Gala Dinners · Luxury Events · Private Celebrations · Band",
      entTitle: "Live Entertainment for Exceptional Events",
      entIntro: "Some evenings call for more than background music. Giovanni Costello combines the sophistication of a pianist with the presence of an international live entertainer. His repertoire of Italian classics, jazz, swing and timeless popular songs is designed for elegant occasions where music should complement the atmosphere and, when the moment calls for it, become the highlight of the evening.",
      categories: [
        { title: "Corporate Events", text: "Sophisticated entertainment for company celebrations, executive dinners, client events, conferences, product launches and corporate receptions." },
        { title: "Gala Dinners", text: "Elegant piano and vocal performances for prestigious dinners, awards ceremonies, charity galas and formal evening events." },
        { title: "Luxury & Private Events", text: "A distinctive live music experience for weddings, private celebrations, exclusive dinners and special occasions." },
        { title: "Big Band Events", text: "For larger productions, Giovanni Costello can perform with a full Big Band, creating the atmosphere of a sophisticated Italian concert evening." },
      ],
      closing: "Available as Piano & Vocals, with Band or with Big Band.",
      photoLabel: "Live Entertainment · Piano & Vocals",
      cta: "Send Inquiry",
    },
    contact: {
      label: "Contact",
      title: "Management & Booking",
      sub: "Inquiries for concerts, galas, TV and press.",
      name: "Name / Company",
      email: "Email",
      subject: "Subject / Occasion",
      message: "Message",
      send: "Send Message",
      success: "Grazie! Your message has been sent.",
      error: "Sending failed. Please try again later.",
    },
    cart: {
      title: "Cart",
      empty: "Your cart is empty.",
      emptyCta: "Discover albums",
      subtotal: "Subtotal",
      shipping: "Shipping",
      free: "Free",
      freeFrom: "Free shipping from €50",
      total: "Total",
      checkout: "Proceed to Checkout",
      continue: "Continue browsing",
      remove: "Remove",
    },
    checkout: {
      title: "Checkout",
      back: "Back to shop",
      contact: "Contact Details",
      address: "Shipping Address",
      firstName: "First name",
      lastName: "Last name",
      email: "Email address",
      phone: "Phone (optional)",
      street: "Street & No.",
      zip: "ZIP code",
      city: "City",
      country: "Country",
      delivery: "Delivery Method",
      standard: "Standard (3–5 business days)",
      express: "Express (1–2 business days)",
      payment: "Payment Method",
      paymentNote: "Payment is processed by a secure payment provider. No payment data is stored on this website.",
      summary: "Your Order",
      legal: "By clicking »Place binding order« you accept the Terms & Conditions and cancellation policy.",
      place: "Place binding order",
      processing: "Processing …",
      empty: "Your cart is empty.",
      emptyCta: "Back to the albums",
      error: "Order failed. Please try again.",
      countries: ["Germany", "Austria", "Switzerland", "Italy"],
    },
    confirmation: {
      title: "Grazie mille!",
      sub: "Thank you for your order.",
      orderNo: "Order number",
      emailNote: "A confirmation will also be sent by email.",
      paymentNote: "Payment will be completed via the selected provider (integration follows).",
      items: "Ordered items",
      total: "Total",
      continue: "Keep discovering the music",
      notFound: "Order not found.",
    },
    footer: {
      tagline: "Italian Singer · Pianist · Entertainer",
      rights: "All rights reserved.",
      impressum: "Imprint",
      privacy: "Privacy",
      follow: "Follow",
    },
    photo: "PHOTO",
    photoHint: "Insert original photo here",
  },
  it: {
    nav: {
      home: "Home", booking: "Biografia", music: "Musica", albums: "Album",
      videos: "Video", gallery: "Galleria", live: "Live", contact: "Contatti",
    },
    hero: {
      kicker: "Italian Singer · Pianist · Entertainer",
      lead: "Passione italiana. Musica senza tempo. Stile inconfondibile. Giovanni Costello unisce canto, pianoforte ed entertainment in momenti speciali: elegante, carismatico e con l'anima dell'Italia.",
      ctaMusic: "Scopri la Musica",
      ctaBook: "Prenota",
      listenOn: "Ascolta su",
      scroll: "Scorri",
    },
    marquee: "IN ALTO MARE · TRUE ITALIAN STORIES · DAL VIVO CON LA SWR BIG BAND · TENDERNESS · SPLENDIDO · IL GIOCO · ",
    about: {
      label: "Capitolo 01 · L'Artista",
      title: "Un gentiluomo al pianoforte",
      chapters: [
        {
          num: "01",
          title: "La voce vellutata dello swing italiano",
          text: "Giovanni Costello incarna il fascino senza tempo del classico gentiluomo italiano. La sua calda voce baritonale unisce la tradizione dei cantautori italiani alle trascinanti sezioni di fiati di una grande big band. Elegante, sicuro, inconfondibile.",
        },
        {
          num: "02",
          title: "Dal conservatorio ai grandi palcoscenici",
          text: "Al pianoforte a coda Giovanni crea intimità e passione allo stesso tempo. Dalle apparizioni TV a The Voice of Germany e Canale 5 ai concerti con la SWR Big Band e ai gala all'aperto: le sue esibizioni sono momenti che restano.",
        },
        {
          num: "03",
          title: "Le sue canzoni, le sue storie",
          text: "Con album come »In Alto Mare«, »True Italian Stories« e »Splendido«, Giovanni racconta storie italiane con il suo stile personale, tra jazz, swing e nostalgia mediterranea.",
        },
      ],
    },
    albums: {
      label: "Capitolo 02 · Discografia",
      title: "Album e Musica",
      sub: "Album originali di Giovanni Costello. Passa il mouse su un album o toccalo per vedere la tracklist.",
      tracklist: "Tracklist",
      buyCd: "Compra il CD",
      added: "aggiunto al carrello",
      listenOn: "Ascolta su",
      year: "Anno",
      tracklistPending: "Tracklist in arrivo.",
      sampleNote: "",
    },
    videos: {
      label: "Capitolo 03 · Palco e Schermo",
      title: "Video ed Esibizioni",
      sub: "Momenti dal vivo, apparizioni TV e videoclip ufficiali, direttamente da YouTube.",
      watchOn: "Guarda su YouTube",
    },
    gallery: {
      label: "Capitolo 04 · Immagini",
      title: "Galleria",
      sub: "Ritratti, palcoscenico, studio e momenti speciali.",
      close: "Chiudi",
    },
    live: {
      label: "Capitolo 05 · In Tour",
      title: "Live e Concerti",
      sub: "Prossimi spettacoli. Nuove date vengono aggiunte continuamente.",
      tickets: "Biglietti",
      soon: "Prossimamente",
      available: "Biglietti disponibili",
      fast: "Quasi esaurito",
      vip: "Solo posti VIP",
      sampleNote: "Date di esempio, da sostituire con i dati ufficiali dei concerti.",
      socialNote: "Le date dei concerti si trovano anche sui social media, ad esempio su Instagram e Facebook.",
    },
    booking: {
      label: "Capitolo 01 · Biografia",
      kicker: "Italian Singer, Pianist & Entertainer per eventi eleganti",
      lead1: "Passione italiana, eleganza musicale e una voce dal carattere inconfondibile. Giovanni Costello ha iniziato il suo percorso musicale da bambino in Italia e lo ha portato dai palcoscenici internazionali alla televisione tedesca. Oggi unisce canto, pianoforte, jazz, pop e classici italiani nel suo stile personale.",
      lead2: "Musica intima al pianoforte, gala eleganti o grandi spettacoli dal vivo con la big band: Giovanni crea momenti speciali e un'atmosfera che unisce le persone. Un vero entertainer italiano con charme, personalità e passione per il grande palcoscenico.",
      tags: "Corporate Events · Gala Dinners · Luxury Events · Private Celebrations · Band",
      entTitle: "Intrattenimento dal vivo per eventi eccezionali",
      entIntro: "Alcune serate richiedono più di un sottofondo musicale. Giovanni Costello unisce la raffinatezza di un pianista alla presenza di un entertainer internazionale. Il suo repertorio di classici italiani, jazz, swing e intramontabili canzoni pop è pensato per occasioni eleganti, dove la musica deve completare l'atmosfera e, quando il momento lo richiede, diventare il momento clou della serata.",
      categories: [
        { title: "Corporate Events", text: "Intrattenimento raffinato per feste aziendali, cene executive, eventi per clienti, conferenze, lanci di prodotto e ricevimenti aziendali." },
        { title: "Gala Dinners", text: "Eleganti performance di pianoforte e voce per cene prestigiose, cerimonie di premiazione, gala di beneficenza ed eventi serali formali." },
        { title: "Luxury & Private Events", text: "Un'esperienza musicale dal vivo inconfondibile per matrimoni, feste private, cene esclusive e occasioni speciali." },
        { title: "Big Band Events", text: "Per produzioni più grandi, Giovanni Costello si esibisce con una Big Band al completo, creando l'atmosfera di una sofisticata serata di concerto italiana." },
      ],
      closing: "Disponibile come Piano e Voce, con Band o con Big Band.",
      photoLabel: "Intrattenimento dal vivo · Piano e Voce",
      cta: "Invia Richiesta",
    },
    contact: {
      label: "Contatti",
      title: "Management e Booking",
      sub: "Richieste per concerti, gala, TV e stampa.",
      name: "Nome / Azienda",
      email: "Email",
      subject: "Oggetto / Occasione",
      message: "Messaggio",
      send: "Invia Messaggio",
      success: "Grazie! Il tuo messaggio è stato inviato.",
      error: "Invio non riuscito. Riprova più tardi.",
    },
    cart: {
      title: "Carrello",
      empty: "Il tuo carrello è vuoto.",
      emptyCta: "Scopri gli album",
      subtotal: "Subtotale",
      shipping: "Spedizione",
      free: "Gratuita",
      freeFrom: "Spedizione gratuita da 50 €",
      total: "Totale",
      checkout: "Vai alla Cassa",
      continue: "Continua a esplorare",
      remove: "Rimuovi",
    },
    checkout: {
      title: "Cassa",
      back: "Torna al negozio",
      contact: "Dati di Contatto",
      address: "Indirizzo di Spedizione",
      firstName: "Nome",
      lastName: "Cognome",
      email: "Indirizzo email",
      phone: "Telefono (opzionale)",
      street: "Via e numero",
      zip: "CAP",
      city: "Città",
      country: "Paese",
      delivery: "Metodo di Spedizione",
      standard: "Standard (3–5 giorni lavorativi)",
      express: "Express (1–2 giorni lavorativi)",
      payment: "Metodo di Pagamento",
      paymentNote: "Il pagamento viene elaborato da un provider sicuro. Nessun dato di pagamento viene memorizzato su questo sito.",
      summary: "Il tuo Ordine",
      legal: "Cliccando su »Effettua ordine vincolante« accetti i Termini e Condizioni e la politica di recesso.",
      place: "Effettua ordine vincolante",
      processing: "Elaborazione …",
      empty: "Il tuo carrello è vuoto.",
      emptyCta: "Torna agli album",
      error: "Ordine non riuscito. Riprova.",
      countries: ["Germania", "Austria", "Svizzera", "Italia"],
    },
    confirmation: {
      title: "Grazie mille!",
      sub: "Grazie per il tuo ordine.",
      orderNo: "Numero ordine",
      emailNote: "Una conferma sarà inviata anche via email.",
      paymentNote: "Il pagamento sarà completato tramite il provider selezionato (integrazione in arrivo).",
      items: "Articoli ordinati",
      total: "Totale",
      continue: "Continua a scoprire la musica",
      notFound: "Ordine non trovato.",
    },
    footer: {
      tagline: "Italian Singer · Pianist · Entertainer",
      rights: "Tutti i diritti riservati.",
      impressum: "Note Legali",
      privacy: "Privacy",
      follow: "Seguici",
    },
    photo: "FOTO",
    photoHint: "Inserisci qui la foto originale",
  },
};
